export default __webpack_public_path__ + "assets/graph-and-line.mp4";